<template>
  <v-card outlined>
    <v-card-title class="py-2">{{ use_language.summary_total }}</v-card-title>
    <v-divider />
    <v-card-text>
      <div class="d-flex justify-space-between">
        <span>{{ use_language.total }}</span>
        <span>{{ formatPrice(subtotal) }}</span>
      </div>
      <div class="d-flex justify-space-between">
        <span>{{ use_language.product_discount }}</span>
        <span class="red--text">- {{ formatPrice(itemDiscount) }}</span>
      </div>
      <div class="d-flex align-center mt-2">
        <span>{{ use_language.bill_discount }}</span>
        <v-spacer />
        <v-text-field
          :value="orderDiscount"
          type="number"
          min="0"
          dense
          hide-details
          class="discount-input"
          style="max-width:120px;"
          @input="$emit('update:orderDiscount', Number($event) || 0)"
        />
      </div>
      <v-divider class="my-3" />
      <div class="d-flex justify-space-between text-h6">
        <span>{{ use_language.net_amount }}</span>
        <span class="primary--text">{{ formatPrice(grandTotal) }} ฿</span>
      </div>
    </v-card-text>
    <v-card-actions class="px-4 pb-4">
      <v-btn
        block
        x-large
        color="primary"
        :loading="loading"
        :disabled="disabled"
        @click="$emit('charge')"
      >
        <v-icon left>mdi-printer-pos</v-icon>
        {{ use_language.collect_and_print_receipt }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { get_languages } from '@/website/global_function'

export default {
  name: 'PosCheckoutPanel',
  props: {
    items: { type: Array, default: () => [] },
    orderDiscount: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return { use_language: {} }
  },
  computed: {
    subtotal () {
      return this.items.reduce(
        (s, it) => s + Number(it.salePrice || 0) * Number(it.quantityInput || 0), 0
      )
    },
    itemDiscount () {
      return this.items.reduce(
        (s, it) => s + Number(it.discount || 0) * Number(it.quantityInput || 0), 0
      )
    },
    grandTotal () {
      return Math.max(0, this.subtotal - this.itemDiscount - Number(this.orderDiscount || 0))
    }
  },
  async created () {
    this.use_language = await this.get_languages(localStorage.getItem('set_language'))
  },
  methods: {
    get_languages,
    formatPrice (v) {
      return Number(v || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.discount-input >>> input {
  text-align: right;
}
</style>
